import React, { Component } from 'react'
import PropTypes from 'prop-types'
import uuid from 'uuid'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { get } from 'lodash'
import { Modal } from 'containers/misc'
import { TaskApprove, TaskReturn } from 'containers/forms/tasks'
import { TasksAwardLeaderNote } from 'components/sections/tasks'
import { Table, Data } from 'components/layout/Table'
import { ButtonGroup, Button } from 'components/misc'
import { tasks as tasksLayout } from 'constants/layout'
import config from 'config'

export default class TasksOfficeAwardsTableSingle extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    modal: PropTypes.func.isRequired,
    onGetAwardLeaderSignOffs: PropTypes.func.isRequired,
    approveModal: PropTypes.func.isRequired,
    returnModal: PropTypes.func.isRequired
  }

  state = {
    awardIdSignoff: null,
    awardIdReturn: null,
    note: null
  }

  key = uuid.v1()

  handleApproveModal = awardIdSignoff => {
    this.setState(
      {
        awardIdSignoff
      },
      () => {
        this.props.modal(`modal-signoff-activity-${this.key}`)
      }
    )
  }

  handleReturnModal = awardIdReturn => {
    this.setState(
      {
        awardIdReturn
      },
      () => {
        this.props.modal(`modal-return-activity-${this.key}`)
      }
    )
  }

  handleShowNote = (id, requestId) => {
    this.props.onGetAwardLeaderSignOffs(id, requestId).then(({ body }) => {
      this.setState(
        {
          note: get(body, 'note')
        },
        () => {
          this.props.modal(`modal-note-show-${this.key}`)
        }
      )
    })
  }

  render() {
    const { data, approveModal, returnModal } = this.props

    return (
      <div>
        <Table ths={tasksLayout.awardsOfficeSignoffSingle}>
          <Data>
            <tr>
              <td>
                <Link to={`${config.publicPath}/participants/${get(data, 'participant.id')}`}>
                  {get(data, 'participant.globalId') ||
                    get(data, 'participant.id')}
                </Link>
              </td>
              <td>
                {get(data, 'participant.firstName')}
              </td>
              <td>
                {get(data, 'participant.lastName')}
              </td>
              <td>
                {get(data, 'participant.email')}
              </td>
              <td>
                <Button
                  type="button"
                  link
                  onClick={() =>
                    this.handleShowNote(
                      data.id,
                      data.awardAwardLeaderSignoffActionId
                    )}
                >
                  <FormattedMessage id="button.view" defaultMessage="View" />
                </Button>
              </td>
              <td className="text--right">
                <ButtonGroup right>
                  <Button
                    type="button"
                    onClick={() => this.handleApproveModal(get(data, 'id'))}
                    intlKey="button.approve"
                    small
                  >
                    Approve
                  </Button>
                  <Button
                    type="button"
                    onClick={() => this.handleReturnModal(get(data, 'id'))}
                    intlKey="button.revise"
                    small
                  >
                    Revise
                  </Button>
                </ButtonGroup>
              </td>
            </tr>
          </Data>
        </Table>
        <Modal id={`modal-signoff-activity-${this.key}`} customActions>
          <TaskApprove
            approve={approveModal}
            id={this.state.awardIdSignoff}
            modal={this.props.modal}
            withNote
          />
        </Modal>
        <Modal id={`modal-return-activity-${this.key}`} customActions>
          <TaskReturn
            returnTask={returnModal}
            id={this.state.awardIdReturn}
            modal={this.props.modal}
          />
        </Modal>
        <Modal
          id={`modal-note-show-${this.key}`}
          closeAction="Close"
          intlKeyClose="modal.close"
        >
          <TasksAwardLeaderNote note={this.state.note} />
        </Modal>
      </div>
    )
  }
}
